import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref } from "vue"

import { onMounted, ref, computed, reactive } from 'vue'
import Modal from '@/hooks/modalType'
import { DcMessage } from '@dc-platform/dc-components'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import {
  partnerContactDelete,
  partnerContactAdd,
  partnerContactEdit,
  partnerContactList
} from '@/api/marketing/marketingManage'
import { useRoute } from 'vue-router'
import type { PartnerManage } from '@/typings/api/marketingManage'
import { contactValidate, concatNameValidate } from '@/utils/validate'
import { listByParamCodes } from '@/api/common'

const __default__ = { name: 'ContactsTable' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const route = useRoute()
const table = ref()
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PartnerManage['partnerContact']>({})
const partner = ref<any>({
  id: null,
  partnerName: ''
})
const paramCodeData = reactive<{
  zbu_partner_role_fbu: []
}>({
  zbu_partner_role_fbu: []
})

const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.id) {
    partnerContactList({
      partnerId: route.query.id,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: ['zbu_partner_role_fbu']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
onMounted(() => {
  getByParamCodes()
  partner.value = {
    id: route.query.id,
    partnerName: route.query.name
  }
})
// 新增
const handleAdd = () => {
  form.value = {}
  visible.value = true
}
// 编辑
const handleEdit = (row: PartnerManage['partnerContact']) => {
  form.value = { ...row }
  visible.value = true
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      if (form.value?.id) {
        await partnerContactEdit(form.value)
        DcMessage.success('编辑成功')
      } else {
        await partnerContactAdd({ ...form.value, partnerId: partner.value.id })
        DcMessage.success('新增成功')
      }
      visible.value = false
      success()
    } catch (error) {}
    loading.value = false
  })
}
// 删除
const handleDelete = (row: PartnerManage['partnerContact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      partnerContactDelete({ id: row.id }).then((res) => {
        table.value.delFetch()
        DcMessage.success('删除成功')
      })
    }
  })
}
const success = () => {
  table.value.fetch()
}
const columns = computed(() => [
  {
    title: '对接人名称',
    dataIndex: 'name'
  },
  {
    title: '性别',
    dataIndex: 'sex',
    dicData: dataConfig.genderEnum,
    filterNoVal: true
  },
  {
    title: '角色',
    dataIndex: 'role',
    dicData: paramCodeData.zbu_partner_role_fbu,
    filterNoVal: true
  },
  {
    title: '手机号',
    dataIndex: 'mobile'
  },
  {
    title: '邮箱',
    dataIndex: 'email'
  },
  {
    title: '微信号',
    dataIndex: 'wechat'
  },
  {
    title: 'QQ号',
    dataIndex: 'qq'
  },
  {
    title: '固定电话',
    dataIndex: 'tel'
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 180
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_table, {
      serial: "",
      columns: columns.value,
      tableId: "fbuPartnerContactsTable",
      onFetch: fetch,
      ref_key: "table",
      ref: table
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleEdit(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 编辑 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, 'fbu_partner_counterpart_edit_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleDelete(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 删除 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, 'fbu_partner_counterpart_del_btn']
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns"]),
    _createVNode(_component_cos_footer_button, {
      loading: loading.value,
      returnName: "DcCosZbuPartnerManage"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAdd())),
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("新增对接人")
          ]),
          _: 1
        }, 8, ["loading"])), [
          [_directive_permission, 'fbu_partner_counterpart_add_btn']
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_cos_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((visible).value = $event)),
      title: form.value.id ? '编辑' : '新增',
      width: "870px",
      onOk: handleSubmit,
      confirmLoading: loading.value
    }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              model: form.value,
              ref_key: "formRef",
              ref: formRef
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dc_layout_card, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, {
                      name: "partnerName",
                      label: "合作伙伴名称",
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: partner.value.partnerName,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((partner.value.partnerName) = $event)),
                          placeholder: "请输入",
                          disabled: true
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "name",
                      span: 12,
                      rules: [
            {
              required: true,
              message: '请输入'
            },
            {
              validator: _unref(concatNameValidate)
            }
          ],
                      label: "对接人名称"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: form.value.name,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.name) = $event)),
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "性别",
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosSelect, {
                          filterNoVal: "",
                          value: form.value.sex,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.sex) = $event)),
                          options: _unref(dataConfig).genderEnum,
                          placeholder: "请选择",
                          "allow-clear": ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      label: "角色",
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          filterNoVal: "",
                          options: paramCodeData.zbu_partner_role_fbu,
                          value: form.value.role,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.role) = $event))
                        }, null, 8, ["options", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "mobile",
                      label: "手机号",
                      span: 12,
                      rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: form.value.mobile,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.mobile) = $event)),
                          placeholder: "请输入，联系方式必填其一"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createVNode(_component_dc_form_item, {
                      name: "email",
                      label: "邮箱",
                      span: 12,
                      rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: form.value.email,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.email) = $event)),
                          placeholder: "请输入，联系方式必填其一"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createVNode(_component_dc_form_item, {
                      name: "wechat",
                      span: 12,
                      label: "微信号",
                      rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: form.value.wechat,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.wechat) = $event)),
                          placeholder: "请输入，联系方式必填其一"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createVNode(_component_dc_form_item, {
                      name: "qq",
                      span: 12,
                      label: "QQ号",
                      rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: form.value.qq,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.qq) = $event)),
                          placeholder: "请输入，联系方式必填其一"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createVNode(_component_dc_form_item, {
                      name: "tel",
                      span: 12,
                      label: "固定电话",
                      rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: form.value.tel,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.tel) = $event)),
                          placeholder: "请输入，联系方式必填其一"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "备注",
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosTextarea, {
                          value: form.value.remark,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.remark) = $event)),
                          maxlength: 2000,
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "confirmLoading"])
  ], 64))
}
}

})